<script>
    import Customers from "@/services/Customers";
    import Swal from "sweetalert2";
    import Games from "@/services/Games";
    import modalAddAnswer from "@/components/modals/games/ModalAddAnswer.vue";
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config.json";
    import ECharts from "vue-echarts";
    import 'echarts/lib/chart/pie';
    import 'echarts/lib/chart/bar';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/title';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/polar';
    import 'echarts/lib/component/toolbox';
    import 'echarts/lib/component/grid';

    export default {
      components: {modalAddAnswer, Layout, PageHeader, 'v-chart': ECharts},

      page: {
        title: "Poll Statistics",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      data() {
        return {
          csrf_token: localStorage.getItem('csrf_token'),
          votes: '',
          player_id: '',
          players: [],
          voteAnswerStatistics: [],
          items: [
            {
              text: "Poll",
              href: "#",
            },
            {
              text: "Poll Statistics",
              active: true,
            },
          ],
          title: "Poll Statistics",
          voteAnswers: [],
          combinedVoteData: [],
          pollStatus: '',
          voteData: [],
          question_id: this.$route.params.id,
          modalData: '',
          totalVotes: null,
          votedCustomers: [],
          showLoader: false,
          isBusy: false,
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100],
          customers:[],
          filter: null,
          filterOn: [],
          sortBy: "created_on",
          sortDesc: true,
          showModal: false,
          tryingToEdit: false,
          variants: ["success", "info", "danger", "secondary"],
          chartData: {},
          fields:[
            {
              key:"customer_name",
              label:"Customer Name",
            },
            {
              key:"answer_id",
              label:"Answer",
            },
            {
              key:"timestamp",
              label:"Timestamp",
            }
          ]

        };
      },

      computed: {
        answers() {
          const stats = this.combinedVoteData.filter(i => i.answer_id);
          const texts = this.combinedVoteData.filter(i => i.answer);

          return texts.map(t => {
            const stat = stats.find(s => s.answer_id === t.id);
            return {
              id: t.id,
              answer: t.answer,
              votes: stat ? stat.votes : 0,
              percentage: stat ? stat.percentage : 0,
            };
          });
        },


      },

      methods: {
        closeModal() {
          this.showModal = false;
        },
        openModalAddAnswer(questionId) {
          this.modalData = questionId
          this.$bvModal.show('add_new_answer')
        },


        async getPoll() {
          try {
            this.showLoader = true
            this.toggleBusy();
            const data = `question_id=${this.question_id}&all_votes=1`
            const response = await Games.getPolls(data)
            this.voteData = response.data.data[0]
            this.showLoader = false
            await this.syncData()
          } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.showLoader = false
            this.totalRows = 0,
            this.customers = [],
            this.totalVotes = 0,
            this.voteData = []


          } finally {
            this.showLoader = false
            this.toggleBusy();
          }
        },



            async deletePollAnswer(id) {
              try {

                const confirmation = await Swal.fire({
                  title: 'Delete Poll Answer?',
                  text: "This Poll Answer  will be deleted!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!'
                });
                if (confirmation.isConfirmed) {
                  const response = await Games.deletePollAnswer(id);
                  this.refreshData()
                  if (response.data.success) {
                    this.syncData();
                    Swal.fire('Deleted!', 'Poll Answer has been deleted.', 'success');
                  } else {
                    Swal.fire('Error', 'Failed to delete Poll Answer', 'error');
                  }
                }
              } catch (error) {
                Swal.fire('Error', 'Failed to delete Poll Answer', 'error');
                console.error('Error deleting Poll:', error);
              }
            },
        editView(data) {
          if (data.length > 0) {
            let chartData = data;
            const values = chartData.map(d => ({
              name: d.answer,
              value: d.votes
            })).filter(d => d.value !== 0);

            const truncate = (str, n = 24) => (str.length > n ? str.slice(0, n - 1) + "…" : str);


            this.chartData = {
              tooltip: {
                trigger: 'item',
                formatter: params => `${params.name}<br/>${params.value} Votes (${params.percent}%)`
              },
              legend: {
                orient: 'horizontal',
                right: 10,
                top: 'bottom',
                formatter: name => truncate(name, 30)

              },
              series: [
                {
                  name: 'Votes',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  // labelLayout: { hideOverlap: true },
                  itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: 16,
                      fontWeight: 'bold'
                    }
                  },
                  label: {
                    show: true,
                    formatter: p => {
                      return `${truncate(p.name, 22)}: ${p.percent}%`;
                    }
                  },
                  data: values.value !== 0 ? values : []
                }
              ]
            };
          } else {
            this.chartData = null;
          }
        },


          refreshData() {
            this.getPoll()
          },
            resetProps(){
                this.tryingToEdit = false
                this.player_id = ''
                this.votes = ''
                this.combinedVoteData = []
                this.voteAnswerStatistics = []
                this.voteAnswers = []
                this.showLoader = false
            },

            getAnswer(answer_id){
                const answer = this.voteAnswers.find(a => a.id === answer_id)
                return answer ? answer.answer : ''
            },

            async syncData(){
                this.totalVotes = this.voteData.statistics.total_votes
                this.voteAnswerStatistics = this.voteData.statistics.answer_statistics
                this.voteAnswers = this.voteData.answers
                this.combinedVoteData = [...this.voteAnswerStatistics,...this.voteAnswers]
                this.pollStatus = this.voteData.status
                this.customers = this.voteData.votes
                this.totalRows = this.customers.length
                this.editView(this.answers)
            }

        },

        mounted() {
          this.getPoll()
        }
    };
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div v-if="showLoader" class="d-flex align-items-center justify-content-center p-3 text-primary">
            <b-spinner large ></b-spinner>
          </div>
         <div class="card-body" v-if="!showLoader">
           <h5 class="card-header fw-bold mb-5" style="font-size: 23px;">{{voteData.question}}</h5>
           <div class="d-flex align-items-center justify-content-evenly gap-5">

             <div class="d-flex flex-column gap-3 mb-4">
               <div>
                 <img :src="voteData.image" style="width: 150px;"/>
               </div>
               <div>
                 <h5 style="font-size:17px;">Total Votes: <span class="fw-normal">{{totalVotes}}</span></h5>
               </div>
               <div >
                 <h5 style="font-size:17px;">Active From: <span class="fw-normal">{{voteData.active_from}}</span></h5>
               </div>
               <div >
                 <h5 style="font-size:17px;">Active To: <span class="fw-normal">{{voteData.active_to}}</span></h5>
               </div>
               <div>
                 <h5 style="font-size:17px;">Status: <span class="badge"
                                   :class="{
                  'bg-danger': pollStatus === 'past' || pollStatus === 'incomplete',
                  'bg-success': pollStatus === 'active' || pollStatus === 'future',
                }"
                 >{{pollStatus}}</span></h5>
               </div>
             </div>
             <div v-if="voteAnswerStatistics.length">
               <v-chart :options="chartData" autoresize />
             </div>
             <div v-else>
               <div ><p style="text-align: center; font-size: 6em; color: rgb(91, 115, 232);"><i data-v-35e293c4="" class="uil-folder-slash"></i></p><p data-v-35e293c4="" style="text-align: center; margin-top: -20px; font-weight: bold;">No data available</p></div>
             </div>
             <div>
               <div class="d-flex gap-3">
                 <h4>Answers</h4>
                 <div v-if="answers.length < 5">
                   <b-button  v-if="pollStatus != 'active' && pollStatus != 'past'" size="sm" class="w-20" style="position: relative; bottom: 5px" variant="outline-primary" @click.prevent="openModalAddAnswer(voteData.id)">+ Add</b-button>
                 </div>
               </div>
               <span class="fw-bold" v-if="!answers.length">No Answers</span>
               <table v-else class="table table-striped table-xl mt-2">
                 <thead>
                 <tr>
                   <th>Answer</th>
                   <th>Percentage</th>
                   <th>Votes</th>
                   <th v-if="pollStatus != 'active' && pollStatus != 'past'">Actions</th>
                 </tr>
                 </thead>
                 <tbody>
                 <tr v-for="a in answers" :key="a.id">
                   <td class="fw-bold" :title="a.answer" style="white-space: normal; word-break: break-word;">{{ a.answer }}</td>
                   <td>{{ a.percentage }}%</td>
                   <td>{{ a.votes }}</td>
                   <td v-if="pollStatus != 'active' && pollStatus != 'past'">
                     <i
                         class="uil uil-trash-alt font-size-18 text-danger"
                         style="cursor: pointer"
                         title="Delete this answer"
                         @click="deletePollAnswer(a.id)"
                     ></i>
                   </td>
                 </tr>
                 </tbody>
               </table>
             </div>
           </div>
           <div>

             <hr class="mb-4 mt-4">
             <div >
               <div>
                 <h4>Customers that voted</h4>
                 <div class="row mt-4">
                   <div class="col-sm-12 col-md-6">
                     <div id="tickets-table_length" class="dataTables_length">
                       <label class="d-inline-flex align-items-center">
                         Show&nbsp;
                         <b-form-select
                             v-model="perPage"
                             size="sm"
                             :options="pageOptions"
                         ></b-form-select
                         >&nbsp;entries
                       </label>
                     </div>
                   </div>
                   <!-- Search -->
                   <div class="col-sm-12 col-md-6">
                     <div
                         id="tickets-table_filter"
                         class="dataTables_filter text-md-end"
                     >
                       <label class="d-inline-flex align-items-center">
                         Search:
                         <b-form-input
                             v-model="filter"
                             type="search"
                             placeholder="Search..."
                             class="form-control form-control-sm ms-2"
                         ></b-form-input>
                       </label>
                     </div>
                   </div>
                   <!-- End search -->
                 </div>
                  <div class="table-responsive mb-0">
                    <b-table
                        :items="customers"
                        :busy="isBusy"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        show-empty
                        empty-text="No Data Found"
                    >
                      <template v-slot:cell(answer_id)="data">

                        {{getAnswer(data.item.answer_id)}}
                      </template>
                      <template v-slot:cell(customer_name)="data">
                        <a :href="`/customers/profile/${data.item.customer_id}`">{{data.item.customer_name ? data.item.customer_name : data.item.customer_email}}</a>
                      </template>

                    </b-table>
                  </div>
                 <div class="row">
                   <div class="col">
                     <div class="dataTables_paginate paging_simple_numbers float-end">
                       <ul class="pagination pagination-rounded mb-0">
                         <!-- pagination -->
                         <b-pagination
                             v-model="currentPage"
                             :total-rows="totalRows"
                             :per-page="perPage"
                         ></b-pagination>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>

             </div>
           </div>
         </div>
        </div>
      </div>
    </div>


    <modalAddAnswer @onRefresh="refreshData" :questionId="modalData" ></modalAddAnswer>

  </Layout>


</template>